import { render, staticRenderFns } from "./FormContactAddresses.vue?vue&type=template&id=897d57ca&"
import script from "./FormContactAddresses.vue?vue&type=script&lang=ts&"
export * from "./FormContactAddresses.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/agent/workspace/SPP/deployment/frontend-erp-spp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('897d57ca')) {
      api.createRecord('897d57ca', component.options)
    } else {
      api.reload('897d57ca', component.options)
    }
    module.hot.accept("./FormContactAddresses.vue?vue&type=template&id=897d57ca&", function () {
      api.rerender('897d57ca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ContactData/FormContactAddresses.vue"
export default component.exports